/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_BetaInputs */

const da_privacy_data_beta = /** @type {(inputs: Privacy_Data_BetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Betaanmodninger:** navn, e-mailadresse, skole, rolle og din besked. Forsøger du at oprette en konto uden en invitation, gemmer vi dit navn og din e-mailadresse som en anmodning, så vi kan invitere dig.`)
};

/** @type {(inputs: Privacy_Data_BetaInputs) => LocalizedString} */
const en_privacy_data_beta = da_privacy_data_beta;

/**

* @param {Privacy_Data_BetaInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_beta = /** @type {((inputs?: Privacy_Data_BetaInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_BetaInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_beta(inputs)
	return /** @type {LocalizedString} */ ("**Betaanmodninger:** navn, e-mailadresse, skole, rolle og din besked. Forsøger du at oprette en konto uden en invitation, gemmer vi dit navn og din e-mailadresse som en anmodning, så vi kan invitere dig.")
});